import { RootState } from "@/store/store";
import { GUID } from "@faro-lotv/foundation";
import { isSiteScapeClusterEntity } from "@faro-lotv/service-wires";
import { selectRevisionEntityMap } from "../store/revision/revision-entity-selectors";

/**
 * @param state The current application state.
 * @param selectionId the ID of the entity that was selected.
 * @returns the ID of the entity that the selection should be applied to.
 */
export function normalizeSelection(state: RootState, selectionId: GUID): GUID {
  const entityMap = selectRevisionEntityMap(state);

  const entity = entityMap[selectionId];
  if (!entity) return selectionId;

  const { parentId } = entity;
  if (!parentId) return selectionId;

  const parent = entityMap[parentId];
  if (!parent) return selectionId;

  // Special handling for site scape:
  // The individual scans cannot be selected directly, only the entire capture
  if (isSiteScapeClusterEntity(parent)) return parent.id;

  return selectionId;
}
